import React from 'react'
import ItemWithStatusOperable from '../ItemSelectable/ItemWithStatusOperable'
import statusOptions from './statusOptions'
import vehicleImg from '../../assets/vehicle-select-icon.svg';
import { t } from 'i18next';

const VehicleOperableCard = ({ vehicle, onClickDelete, onCLickEdit }) => {
    return (
        <ItemWithStatusOperable
            statusLabel={vehicle.vehicle_status ? t(statusOptions[vehicle.vehicle_status.vehicle_general_status].label) : ''}
            statusColor={vehicle.vehicle_status ? statusOptions[vehicle.vehicle_status.vehicle_general_status].color : ''}
            name={`vehicle-${vehicle.vehicle_natural_id}`}
            onClickDelete={onClickDelete}
            onCLickEdit={onCLickEdit}
        >
            <div className='d-flex align-items-center gap-2'>
                <img src={vehicleImg} alt="" />
                <div>
                    <p className='m-0 vehicleName-card'>{vehicle.vehicle_brand} {vehicle.vehicle_model} {vehicle.vehicle_year}</p>
                    <p className='m-0 vehiclePatent-card'>{vehicle.vehicle_natural_id}</p>
                    {
                        vehicle.is_assigned ?
                            <p className='m-0 assigened-text'>{t('ASSIGNED')}</p>
                            :
                            null
                    }
                    {
                        vehicle?.vehicle_status?.is_excepted === true ?
                            <p className='vehiclePatent-card m-0'>{t('EXCEPTED')}</p>
                            :
                            null
                    }
                </div>
            </div>
        </ItemWithStatusOperable>

    )
}

export default VehicleOperableCard